import HttpRequest from '@/utils/axios'
import config from '@/config'
let nodeEnv = process.env.VUE_APP_ENV; //当前环境, 正式环境: NODE_ENV
let vueEnv=process.env.VUE_APP_ENV;
let testEnv = window.location.origin === 'https://cover-cloud-test.data-test.thecover.cn'; // 判断测试环境
let baseUrl = nodeEnv === 'development' ?  config.baseUrl.dev : testEnv ? config.baseUrl.test : config.baseUrl.pro;
const axios = new HttpRequest(baseUrl)
export default axios
